import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Dropdown,
  Image,
  Layout,
  Menu,
  message,
  Row,
  Space,
  Switch,
  Typography,
} from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";

import btnEdit from "../../assets/icon/edit-2.svg";
import sms from "../../assets/icon/sms.svg";
import lock from "../../assets/icon/lock.svg";
import notification from "../../assets/icon/notification.svg";
import cards from "../../assets/icon/cards.svg";
import category from "../../assets/icon/category-2.svg";
import chart from "../../assets/icon/chart.svg";
import dashboard from "../../assets/icon/element-4.svg";
import folder from "../../assets/icon/folder-open.svg";
import fullfillment from "../../assets/icon/fullfillment.svg";
import messageText from "../../assets/icon/message-text.svg";
import note from "../../assets/icon/note.svg";
import profile from "../../assets/icon/profile-2user.svg";
import routing from "../../assets/icon/routing.svg";
import securityUser from "../../assets/icon/security-user.svg";
import userSquare from "../../assets/icon/user-square.svg";
import setting from "../../assets/icon/setting-2.svg";

import superkul from "../../assets/image/superkul-logo.png";
import newOrder from "../../assets/icon/note-new-order.svg";
import avatar from "../../assets/image/avatar.png";
import ellipseRed from "../../assets/icon/ellipse-2.svg";

import WarningModal from "../../components/modal/warning";
import SuccessModal from "../../components/modal/success";

import {
  getUserPermission,
  setAuthToken,
  setCurrentUser,
  setLoginStatus,
  setRefreshToken,
  setTitleBreadCumbs,
} from "../../stores/auth/actions";

import { fetchNewOrders } from "../../stores/masterData/actions";

import { useDispatch, useSelector } from "react-redux";
import {
  generateErrorMessage,
  sendDeleteRequest,
  sendGetRequest,
  sendPatchRequest,
  sendPostMultipartRequest,
} from "../../services/request-adapter";

import ProfileModal from "../../components/modal/profile/profile";
import UpdateEmailModal from "../../components/modal/profile/update-email";
import UpdatePasswordModal from "../../components/modal/profile/update-password";
import NotificationList from "../modal/notification-list";

const { Title, Text } = Typography;
const { Header, Content, Footer, Sider } = Layout;

const OrganismLayout = ({ withoutSider, children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();

  const { user, titleBreadCumbs, userPermissions } = useSelector(
    (state) => state.auth
  );
  const { totalUnread } = useSelector((state) => state.masterData);
  const { newOrders } = useSelector((state) => state.masterData);

  const user_detail = user?.profile;
  const [role, setRole] = useState('')

  const [autoAssign, setAutoAssign] = useState(false);
  const [disableAutoAssignModal, setDisableAutoAssignModal] = useState({
    visible: false,
  });
  const [logoutModal, setLogoutModal] = useState({ visible: false });
  const [fetch, setFetch] = useState(false);

  const [profileImage, setProfileImage] = useState(null);
  const [profileModal, setProfileModal] = useState({ visible: false });
  const [updateEmailModal, setUpdateEmailModal] = useState(false);
  const [updatePasswordModal, setUpdatePasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [successModal, setSuccessModal] = useState({ visible: false });
  const [hasDetail, setHasDetail] = useState(false);
  const [notified, setNotified] = useState(false);

  const menus = [
    {
      name: "Dashboard",
      icon: dashboard,
      link: "/",
      value: "view-dashboard",
    },
    {
      name: "Manage Order",
      icon: note,
      value: "view-orders",
      children: [
        { name: "Customer Order", link: "/customer-order", submenu: "" },
        { name: "Dedicated Order", link: "/dedicated-order", submenu: "" },
        { name: "Dispatch", link: "/drop", submenu: "" },
        { name: "Order Planning", link: "/order-planning", submenu: "" },
        { name: "Superkul Truck", link: "/superkul-truck", submenu: "" },
        // { name: "Pre-Order LTL", link: "/pre-order", submenu: "" },
      ],
    },
    {
      name: "Manage Trip",
      icon: routing,
      value: "view-trip",
      children: [
        { name: "All Trip", link: "/all-trip", submenu: "" },
        { name: "Trip Planning", link: "/trip-planning", submenu: "" },
        { name: "Rejected Trip", link: "/rejected-trip", submenu: "" },
      ],
    },
    {
      name: "Fullfillment Service",
      icon: fullfillment,
      value: "crud-fullfillment",
      children: [
        { name: "Data Cross Docking", link: "/data-crossdocking", submenu: "" },
      ],
    },
    {
      name: "Manage Driver",
      icon: userSquare,
      value: "view-manage-driver",
      children: [
        { name: "List Driver", link: "/list-driver", submenu: "" },
        { name: "Attendance", link: "/attendance", submenu: "view-driver-attendance" },
        { name: "Rating", link: "/rating", submenu: "" },
        {
          name: "Request Maintenance",
          link: "/request-maintenance",
          submenu: "",
        },
        { name: "Driver Schedule", link: "/driver-schedule", submenu: "view-driver-schedule" },
        { name: "Request Time Off", link: "/request-timeoff", submenu: "" },
        { name: "Vehicle Loan", link: "/vehicle-loan", submenu: "" },
      ],
    },
    {
      name: "Finance Report",
      icon: cards,
      value: "view-finance-report",
      children: [
        { name: "Invoice Truck", link: "/invoice-truck", submenu: "view-invoice-truck" },
        { name: "Invoice List", link: "/invoice-order", submenu: "view-invoice-order" },
        { name: "Deposit Analysis", link: "/deposit-analysis", submenu: "view-deposit-analysis" },
        { name: "Additional Driver Transactions", link: "/additional-driver-transactions", submenu: "view-additional-driver-transactions" },
        { name: "Driver Wallet", link: "/driver-wallet", submenu: "view-driver-wallet" },
        { name: "Drop Incentive & Salary", link: "/drop-incentive", submenu: "view-drop-incentive" },
        { name: "Withdrawal Driver", link: "/withdrawal-driver", submenu: "view-withdrawal-driver" },
        { name: "Withdrawal Vendor", link: "/withdrawal-vendor", submenu: "view-withdrawal-vendor" },
      ],
    },
    {
      name: "Analytic",
      icon: chart,
      value: "view-performance-report",
      children: [
        { name: "Performance Report", link: "/performance-report", submenu: "view-perform-report" },
        { name: "Gross Margin Analytic", link: "/gross-margin-analytic", submenu: "view-gross-margin" },
      ]
    },
    // {
    //   name: "Manage Complain",
    //   icon: messageText,
    //   link: "manage-complain",
    //   value: "view-manage-complaint",
    // },
    {
      name: "Role Management",
      icon: securityUser,
      link: "role-management",
      value: "view-role-permission",
    },
    {
      name: "User Management",
      icon: profile,
      link: "user-management",
      value: "view-user-management",
    },
    {
      name: "Setting",
      icon: setting,
      value: "view-settings",
      children: [
        { name: "Privacy Policy", link: "/privacy-policy", submenu: "" },
        { name: "Terms & Conditions", link: "/terms-conditions", submenu: "" },
      ],
    },
    {
      name: "Master Data",
      icon: folder,
      value: "view-master-data",
      children: [
        {
          name: "Additional Service",
          link: "/additional-service",
          submenu: "view-additional-service",
        },
        { name: "Customer", link: "/customer", submenu: "view-customer" },
        {
          name: "Customer Corporate",
          link: "/customer-corporate",
          submenu: "view-customer-corporate",
        },
        {
          name: "Customer Address Label",
          link: "/customer-address-label",
          submenu: "view-customer-corporate",
        },
        {
          name: "Outsource",
          link: "/outsource",
          submenu: "view-outsource",
        },
        {
          name: "Driver Incentive",
          link: "/driver-incentive",
          submenu: "view-driver-incentive",
        },
        {
          name: "Driver Rate",
          link: "/driver-rate",
          submenu: "view-driver-rates",
        },
        {
          name: "Driver Work Types",
          link: "/driver-work",
          submenu: "driver-work",
        },
        {
          name: "Package Category",
          link: "/package-category",
          submenu: "view-package-category",
        },
        { name: "Pool", link: "/pool", submenu: "view-pool" },
        {
          name: "Price Based",
          link: "/price-based",
          submenu: "view-price-based",
        },
        {
          name: "Price Superkul Truck",
          link: "/price-superkul",
          submenu: "view-price-superkul",
        },
        { name: "Promo", link: "/promo", submenu: "view-promo" },
        {
          name: "Service Price",
          link: "/service-price",
          submenu: "view-service-price",
        },
        {
          name: "Service Name",
          link: "/service-name",
          submenu: "view-service-name",
        },

        { name: "Vehicle", link: "/vehicle", submenu: "view-vehicle" },
        {
          name: "Vehicle Type",
          link: "/vehicle-type",
          submenu: "view-vehicle-type",
        },
        { name: "Vendor", link: "/vendor", submenu: "view-vendor" },
        {
          name: "Warehouse",
          link: "/warehouse",
          submenu: "view-warehouse",
        },
      ],
    },
  ];

  const childMaster = userPermissions.flatMap((user) =>
    menus
      .filter((x) => x.children)
      .flatMap((x) => x.children)
      .filter((i) => i?.submenu === user.name)
  );

  const childdd =
    menus.flatMap((men) => {
      let modifyChild = []
      if (men.children) {
        men?.children.map((child) => {
          userPermissions.map((perm) => {
            if (child.submenu === perm.name) {
              modifyChild.push(child)
            }
          })
        })
      }
      return modifyChild

      // userPermissions.map((x) => {
      //   if (men.children) {
      //     // men.map((a) => {
      //     //   if (a?.submenu === x.name) {
      //     //     console.log(men)
      //     //   }
      //     // })
      //   }
      // })
    })

  const newMenus =
    menus.flatMap((men) => {
      let modifyMenu = []
      userPermissions.map((x) => {
        if (x.name === men.value) {
          const dat = {
            key: men.link?.concat(".", men.name),
            icon: <img alt="icon-sidebar" src={men.icon} />,
            label: men.name,
            children:
              men.name === "Master Data"
                ? childdd.map((c) => ({
                  key: c.link?.concat(".", c.name, "#", men.name),
                  label: c.name,
                }))
                : men.children?.map((el) => {
                  return {
                    key: el.link?.concat(".", el.name, "#", men.name),
                    label: el.name,
                  }
                })
          };
          modifyMenu.push(dat)
        }
      })
      return modifyMenu
    });

  // const mennn = 

  const newOrderNotification = () => {
    if (
      titleBreadCumbs?.titleParent === "Dashboard" &&
      newOrders !== undefined &&
      newOrders > 0
    ) {
      setNotified(true);
    } else {
      setNotified(false);
    }
  };

  const openMenu = (e) => {
    const pathKey = e.key;
    const linkKey = pathKey.split(".")[0];
    const titleKey = pathKey.split(".")[1];

    const splitTitleKey = titleKey.split("#");

    const parentKey =
      splitTitleKey.length > 1 ? splitTitleKey[1] : splitTitleKey[0];

    const childKey = splitTitleKey.length > 1 && splitTitleKey[0];

    dispatch(
      setTitleBreadCumbs({
        titleParent: parentKey,
        titleChild: childKey,
        link: linkKey,
      })
    );
    navigate(e.key.split(".")[0]);
  };

  const handleLogout = async () => {
    try {
      await sendDeleteRequest("/logout");

      navigate("/login");
      setLogoutModal({ visible: false });

      dispatch(setAuthToken(null));
      dispatch(setLoginStatus(false));
      dispatch(setRefreshToken(null));
    } catch (error) {
      message.error(generateErrorMessage(error));
    }
  };

  const handleChangeSwitch = async (checked) => {
    try {
      if (checked) {
        await sendPatchRequest("/trip-planning/auto-assign?status=1");
        setSuccessModal({
          visible: true,
          message: "Auto Assign has been successfully reactivated",
        });
        setAutoAssign(true);
      } else {
        setDisableAutoAssignModal({ visible: true });
      }
    } catch (error) {
      message.error(generateErrorMessage(error));
    }
  };

  const handleDisableAutoAssign = async () => {
    try {
      await sendPatchRequest("/trip-planning/auto-assign?status=0");
      setAutoAssign(false);
      setDisableAutoAssignModal({ visible: false });
    } catch (error) {
      message.error(generateErrorMessage(error));
    }
  };

  const updatePassword = async (values) => {
    let params = {
      old_password: values.old_password,
      new_password: values.new_password,
      new_password_confirmation: values.password_confirmation,
    };

    setIsSubmit(true);
    try {
      await sendPatchRequest("/users/password", params);

      setFetch(true);
      setUpdatePasswordModal(false);
      setSuccessModal({
        update: true,
        visible: true,
        message:
          "Password has been successfully updated, please log back into your account",
      });
    } catch (error) {
      message.error(generateErrorMessage(error));
    } finally {
      setIsSubmit(false);
    }
  };

  const onFinish = async (values) => {
    let params = profileModal.visible
      ? {
        first_name: values.firstName,
        last_name: values.lastName,
      }
      : {
        email: values.email,
        password: values.password,
      };

    if (profileImage) params.profile_image = profileImage;

    setIsSubmit(true);
    try {
      profileModal.visible
        ? await sendPostMultipartRequest("users", params)
        : await sendPatchRequest("users/email", params);

      setFetch(true);
      setSuccessModal({ visible: true });
      setProfileImage(null);
      if (profileModal.visible)
        setProfileModal({ ...profileModal, visible: false });
      if (updateEmailModal) setUpdateEmailModal(false);
    } catch (error) {
      message.error(generateErrorMessage(error));
    } finally {
      setIsSubmit(false);
    }
  };

  const Profile = () => {
    return (
      <Row
        style={{
          padding: "24px",
          background: "#ffffff",
          boxShadow: "0px 40px 100px rgba(68, 68, 79, 0.1)",
          borderRadius: "10px",
          width: "365px",
          height: "395px",
        }}
        gutter={[0, 16]}
      >
        <Col span={24}>
          <Title level={5}>Profile</Title>
        </Col>
        <Col span={24}>
          <div
            style={{
              height: "1px",
              background: "#F3F3F3",
              borderRadius: "1px",
            }}
          />
        </Col>
        <Col
          onClick={() => setProfileModal({ type: "profile", visible: true })}
          span={7}
          className="relative pointer"
        >
          <Image
            style={{ borderRadius: "100%", marginRight: "24px" }}
            width={70}
            height={70}
            src={user_detail?.profile_image_link}
            fallback={avatar}
            preview={false}
          />
          <div
            className="absolute"
            style={{
              background: "#ffffff",
              borderRadius: "100%",
              width: 30,
              height: 30,
              boxShadow: "0px 5px 30px rgba(0, 0, 0, 0.25)",
              left: 40,
              top: 40,
              display: "flex",
              alignItems: "center",
              padding: "5px",
              gap: "16px",
            }}
          >
            <img src={btnEdit} alt="btn" />
          </div>
        </Col>
        <Col span={17}>
          <Space direction="vertical">
            <Title level={5}>
              {user_detail?.first_name} {user_detail?.last_name ?? ""}
            </Title>
            <Text>{user?.email}</Text>
          </Space>
        </Col>
        <Col span={22} onClick={() => setUpdateEmailModal(true)}>
          <b className="pointer custom-hover">Edit Email Address</b>
        </Col>
        <Col span={2}>
          <img src={sms} alt="sms" />
        </Col>
        <Col span={22} onClick={() => setUpdatePasswordModal(true)}>
          <b className="pointer custom-hover">Edit Password</b>
        </Col>
        <Col span={2}>
          <img src={lock} alt="lock" />
        </Col>
        <Col span={24}>
          <Button
            block
            danger
            type="primary"
            size="large"
            onClick={() => setLogoutModal({ visible: true })}
          >
            Logout
          </Button>
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    const controller = new AbortController();

    const getProfile = async () => {
      setLoading(true);
      try {
        const { data } = await sendGetRequest("/profile?include=roles", {
          signal: controller.signal,
        });

        const res = await sendGetRequest("/auto-assign", {
          signal: controller.signal,
        });

        setAutoAssign(res.data.status);
        setRole(data?.data[0]?.name)
        dispatch(setCurrentUser(data?.data[0] ?? data?.data));
        setFetch(false);
      } catch (error) {
        message.error(generateErrorMessage(error));
      } finally {
        setLoading(false);
      }
    };

    getProfile();

    return () => {
      controller.abort();
    };
  }, [fetch]);

  useEffect(() => {
    location.pathname.split("/").filter((el) => {
      if (el === "detail") {
        setHasDetail(true);
      } else {
        setHasDetail(false);
      }
    });
    if (location.pathname === "/") {
      dispatch(
        setTitleBreadCumbs({
          link: "/",
          titleParent: "Dashboard",
          titleChild: "Dashboard",
        })
      );
    }
  }, [location]);

  useEffect(() => {
    (async () => {
      fetchNewOrders();
    })();

    dispatch(getUserPermission());
  }, []);

  return (
    <Layout>
      {withoutSider ? null : (
        <Sider width={220} theme="light" className="h-screen overflow-auto">
          <Row
            justify="center"
            align="middle"
            className="p1r"
            style={{ marginBottom: "1rem" }}
          >
            <img height={40} width={152} src={superkul} alt="logo" />
          </Row>
          <Menu
            mode="inline"
            items={newMenus}
            onClick={openMenu}
            defaultSelectedKeys={[
              `${titleBreadCumbs?.link}.${titleBreadCumbs?.titleParent}`,
            ]}
          />
        </Sider>
      )}

      <Layout className="h-screen overflow-auto">
        <Row
          justify="space-between"
          style={{
            backgroundColor: "#FCFCFD",
            padding: "1rem 2rem",
          }}
        >
          {withoutSider ? (
            <Col
              className="pointer custom-hover"
              onClick={() => navigate("/", { replace: true })}
            >
              <img height={40} width={152} src={superkul} alt="error" />
            </Col>
          ) : (
            <Col>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "1rem",
                }}
              >
                <Title level={5}>{titleBreadCumbs?.titleParent}</Title>
                {notified && (
                  <Link to={`/customer-order`}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#E23A0F",
                        color: "#fff",
                        padding: "3px 8px 3px 8px",
                        borderRadius: "15px",
                        columnGap: "0.5rem",
                      }}
                    >
                      <img src={newOrder} alt="new order" />
                      <span>You Have a New Order</span>
                    </div>
                  </Link>
                )}
              </div>
              {titleBreadCumbs?.titleParent !== "Dashboard" && (
                <Breadcrumb className="fs-12">
                  <Breadcrumb.Item>
                    {titleBreadCumbs?.titleParent}
                  </Breadcrumb.Item>
                  {titleBreadCumbs?.titleChild && (
                    <Breadcrumb.Item>
                      <Link
                        className={hasDetail ? "" : "text-primary"}
                        to={titleBreadCumbs?.link}
                      >
                        {titleBreadCumbs.titleChild}
                      </Link>
                    </Breadcrumb.Item>
                  )}
                  {hasDetail && (
                    <Breadcrumb.Item>
                      <span className="text-primary">Detail</span>
                    </Breadcrumb.Item>
                  )}
                </Breadcrumb>
              )}
            </Col>
          )}

          <Row align="middle">
            <Space size="large">
              {user?.roles?.data[0]?.name === 'admin-outsource' ?
                null :
                <Space className="">
                  <span className="mr-2">Auto Assign</span>
                  <Switch
                    checked={autoAssign}
                    onChange={handleChangeSwitch}
                    style={{
                      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.3)",
                    }}
                  />
                </Space>
              }
              <Dropdown trigger={["click"]} dropdownRender={() => <NotificationList />}>
                <div style={{ position: "relative" }}>
                  {totalUnread > 0 && (
                    <img
                      style={{
                        position: "absolute",
                        right: 2,
                      }}
                      src={ellipseRed}
                      alt="dot-red"
                    />
                  )}
                  <img src={notification} alt="bell" className="pointer" />
                </div>
              </Dropdown>

              <Dropdown trigger={["click"]} dropdownRender={() => <Profile />}>
                <img
                  className="pointer"
                  style={{ borderRadius: "100%" }}
                  width={50}
                  height={50}
                  alt="profile"
                  src={user_detail?.profile_image_link ?? avatar}
                />
              </Dropdown>
            </Space>
          </Row>
        </Row>
        <div style={{ padding: "1rem 2rem" }}>{children}</div>
      </Layout>

      <ProfileModal
        title="Edit User"
        loading={loading}
        userDetail={user_detail}
        open={profileModal}
        setOpen={setProfileModal}
        profileImage={profileImage}
        setProfileImage={setProfileImage}
        isSubmit={isSubmit}
        onFinish={onFinish}
      />

      <UpdateEmailModal
        open={updateEmailModal}
        setOpen={setUpdateEmailModal}
        isSubmit={isSubmit}
        onFinish={onFinish}
      />

      <UpdatePasswordModal
        open={updatePasswordModal}
        setOpen={setUpdatePasswordModal}
        onFinish={updatePassword}
        isSubmit={isSubmit}
      />

      <WarningModal
        open={logoutModal}
        setOpen={setLogoutModal}
        onOk={handleLogout}
        message="Do you want logout from this account?"
      />

      <WarningModal
        open={disableAutoAssignModal}
        setOpen={setDisableAutoAssignModal}
        onOk={handleDisableAutoAssign}
        message={`Are you sure you disable "Auto Assign"?`}
      />

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        message={successModal.message ?? "Profile successfully updated"}
        onOk={successModal.update ? handleLogout : false}
      />
    </Layout>
  );
};

export default OrganismLayout;
